import React from 'react';
import { Card } from './ui/card';

const Gallery = () => {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-gray-900 mb-4">Milestones & Impact</h2>
          <div className="w-20 h-1 bg-gradient-to-r from-teal-500 via-purple-500 to-pink-500 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Celebrating academic excellence and community leadership
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <Card className="overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
            <div className="relative h-96">
              <img 
                src="https://customer-assets.emergentagent.com/job_leadership-impact-3/artifacts/k6kqilvq_e91ec5e1-acc6-4ec2-b815-5b16f5497e42.jpeg"
                alt="MBA Graduation"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6 bg-gradient-to-br from-purple-50 to-pink-50">
              <h3 className="text-xl font-bold text-gray-900 mb-2">MBA Graduate</h3>
              <p className="text-gray-600">University of Nebraska at Omaha - Master of Business Administration</p>
            </div>
          </Card>

          <Card className="overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
            <div className="relative h-96">
              <img 
                src="https://customer-assets.emergentagent.com/job_leadership-impact-3/artifacts/syym1tjr_75bd124a-3216-4b7a-8088-9e845f4cd52d.jpeg"
                alt="Academic Achievement"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6 bg-gradient-to-br from-teal-50 to-cyan-50">
              <h3 className="text-xl font-bold text-gray-900 mb-2">Academic Excellence</h3>
              <p className="text-gray-600">Celebrating educational milestones and lifelong learning commitment</p>
            </div>
          </Card>

          <Card className="overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
            <div className="relative h-96">
              <img 
                src="https://customer-assets.emergentagent.com/job_leadership-impact-3/artifacts/5o7r2i7q_fa8dfd01-9561-48e9-a156-f8258d61d906.jpeg"
                alt="Business Project Presentation"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6 bg-gradient-to-br from-orange-50 to-rose-50">
              <h3 className="text-xl font-bold text-gray-900 mb-2">Strategic Consulting</h3>
              <p className="text-gray-600">Consulting with Afromaha on financial viability and strategic sponsorship strategies</p>
            </div>
          </Card>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <Card className="overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
            <div className="relative h-96">
              <img 
                src="https://customer-assets.emergentagent.com/job_leadership-impact-3/artifacts/lqqrtobu_AECDF70D-71EE-475E-A40E-384331C759C7.jpeg"
                alt="Meeting with Nebraska Governor Jim Pillen"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6 bg-gradient-to-br from-red-50 to-rose-50">
              <h3 className="text-xl font-bold text-gray-900 mb-2">High-Level U.S. Business Summit</h3>
              <p className="text-gray-600">Attended exclusive invite-only global investors summit in America, featuring Nebraska Governor Jim Pillen and international business leaders</p>
            </div>
          </Card>

          <Card className="overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
            <div className="relative h-96">
              <img 
                src="https://customer-assets.emergentagent.com/job_leadership-impact-3/artifacts/nqoekvr0_9d44de41-1ae8-4d49-ac08-6d41882728e9.jpeg"
                alt="Global Investors Meeting"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6 bg-gradient-to-br from-amber-50 to-yellow-50">
              <h3 className="text-xl font-bold text-gray-900 mb-2">International Business Delegation</h3>
              <p className="text-gray-600">Participating in exclusive global investors and business professionals summit</p>
            </div>
          </Card>

          <Card className="overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
            <div className="relative h-96">
              <img 
                src="https://customer-assets.emergentagent.com/job_leadership-impact-3/artifacts/ut83088l_867cae63-f66e-4294-b7fd-a781cba4bf73.jpeg"
                alt="Professional Collaboration"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6 bg-gradient-to-br from-blue-50 to-indigo-50">
              <h3 className="text-xl font-bold text-gray-900 mb-2">Professional Collaboration</h3>
              <p className="text-gray-600">Building partnerships and working with diverse teams to drive organizational success</p>
            </div>
          </Card>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mt-8">
          <Card className="overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
            <div className="relative h-96">
              <img 
                src="https://customer-assets.emergentagent.com/job_leadership-impact-3/artifacts/bybpbd84_4dee0b77-fae5-4415-91c6-c032cfe341bb.jpeg"
                alt="Conference & Networking"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6 bg-gradient-to-br from-cyan-50 to-teal-50">
              <h3 className="text-xl font-bold text-gray-900 mb-2">Conference & Networking</h3>
              <p className="text-gray-600">Engaging with industry leaders and expanding professional networks at key events</p>
            </div>
          </Card>

          <Card className="overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
            <div className="relative h-96">
              <img 
                src="https://customer-assets.emergentagent.com/job_leadership-impact-3/artifacts/0a2g4uc7_9bd4e1d4-6439-4483-801e-2d91a1f9fab9.jpeg"
                alt="Community Project Leadership"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6 bg-gradient-to-br from-green-50 to-emerald-50">
              <h3 className="text-xl font-bold text-gray-900 mb-2">Community Project Leadership</h3>
              <p className="text-gray-600">Leading site visits and community development initiatives with dedicated teams</p>
            </div>
          </Card>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mt-8">
          <Card className="overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
            <div className="relative h-96">
              <img 
                src="https://customer-assets.emergentagent.com/job_leadership-impact-3/artifacts/o92g6ga2_6967cf46-a3b8-438e-ba06-fa34cedb44dc.jpeg"
                alt="LinkedIn Coaches Collaboration"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6 bg-gradient-to-br from-sky-50 to-blue-50">
              <h3 className="text-xl font-bold text-gray-900 mb-2">LinkedIn Coaches Collaboration</h3>
              <p className="text-gray-600">Professional coaching and mentorship collaboration with LinkedIn Coaches team, empowering professionals globally</p>
            </div>
          </Card>

          <Card className="overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
            <div className="relative h-96">
              <img 
                src="https://customer-assets.emergentagent.com/job_leadership-impact-3/artifacts/8j3gsudw_ae77908d-2ebd-4779-8f45-851177631e10.jpeg"
                alt="Grow with Google Nebraska Partnership"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6 bg-gradient-to-br from-slate-50 to-zinc-50">
              <h3 className="text-xl font-bold text-gray-900 mb-2">Grow with Google Nebraska</h3>
              <p className="text-gray-600">Strategic partnership with Google's entrepreneurship and digital skills development initiative in Nebraska</p>
            </div>
          </Card>

          <Card className="overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
            <div className="relative h-96">
              <img 
                src="https://customer-assets.emergentagent.com/job_leadership-impact-3/artifacts/ekhtep18_639ac2c5-7fd5-46ea-959b-e342bf279b80.jpeg"
                alt="Youth Advocacy Work"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6 bg-gradient-to-br from-violet-50 to-purple-50">
              <h3 className="text-xl font-bold text-gray-900 mb-2">Youth Development Advocacy</h3>
              <p className="text-gray-600">Youth development advocate and enthusiast, partnering with CASA to amplify children's voices and empower the next generation</p>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Gallery;